import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-6ee04d6b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "py-2" }

import { ref, onMounted, onBeforeMount } from "vue";
	import { boolean } from "yup/lib/locale";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'TabBarTag',
  props: {
		tabProps: {
			type: Array,
			default: [
				{ name: "items1", label: "Item 1" },
				{ name: "items2", label: "Item 2" },
			],
		},
		switch: {
			type: Boolean,
			default: true,
		},
		tabCentered: {
			type: Boolean,
			default: false,
		},
		setCurrentTab: {
			type: String,
			default: "",
		},
	},
  emits: ["currenttab"],
  setup(__props, { emit: __emit }) {

	const tabState: any = ref();
	const targetedTabIndex: any = ref(-1);
	const targetedTabName: any = ref(null);

	// Create events
	const emit = __emit;

	const props: any = __props;

	const changeTabState = (index: number, tabName: string) => {
		tabState.value = props.tabProps.map((tab: any, i: number) => {
			if (i == index) return { show: true };
			else return { show: false };
		});

		emit("currenttab", tabName);
};

const setTargetedTabIndex = () => {
	props.tabProps.every((tab: any, index: number) => {
		if (tab.name == targetedTabName.value) {
			targetedTabIndex.value = index;
			return false;
		}
		else return true;
	});
	return targetedTabIndex.value;
};

onBeforeMount(() => {

	// on initialise le tab cible passé en props
	targetedTabName.value = props.setCurrentTab
	// on recupere/configure son index
	setTargetedTabIndex()

	// enable the current tab
	tabState.value = props.tabProps.map((tab: any, index: number) => {

		// we activate the tab provided
		if (tab.name == targetedTabName.value) {
			//targetIndex = getTabIndex(targetedTabName)
			return { show: true }
		}
		// we activate the first tab
		else {

			if (index == 0 && targetedTabIndex.value == -1 ) return { show: true };
			else return { show: false };

		}
	});
	// console.log("tabState.value: ", tabState.value);

	if (props.tabProps.length != 0) {
		if (targetedTabIndex.value == -1) emit("currenttab", props.tabProps[0].name);
		else emit("currenttab", props.tabProps[targetedTabIndex.value].name);
	}
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("nav", {
      class: _normalizeClass(["", {
					'flex flex-row mb-2 border-b border-b-gray-500': true,
					'justify-center': __props.tabCentered,
				}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabProps, (tab, index) => {
        return (_openBlock(), _createElementBlock("span", {
          key: index,
          class: _normalizeClass({
					'px-4 py-2 text-center bg-gray-700 cursor-pointer hover:bg-gray-900': true,
					'bg-gray-900': tabState.value[index].show,
				}),
          onClick: (e) => changeTabState(index, tab.name)
        }, _toDisplayString(tab.label ?? "the label is undefined"), 11, _hoisted_2))
      }), 128))
    ], 2),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tabProps, (tab, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass({ hidden: !tabState.value[index].show })
        }, [
          _renderSlot(_ctx.$slots, tab.name ?? index, {}, () => [
            _createTextVNode(_toDisplayString(tab.label) + " content", 1)
          ])
        ], 2))
      }), 128))
    ])
  ]))
}
}

})